import { Box, styled } from "@mui/material";

export const ErrorMessage = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.main, // Arka plan rengini error.main yap
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  textAlign: 'center',
  color: '#fff', // Yazı rengini beyaz yap
  '& > *:not(:last-child)': {
    marginBottom: theme.spacing(1)
  },
  animation: 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
  '@keyframes shake': {
    '10%, 90%': {
      transform: 'translate3d(-1px, 0, 0)',
    },
    '20%, 80%': {
      transform: 'translate3d(2px, 0, 0)',
    },
    '30%, 50%, 70%': {
      transform: 'translate3d(-4px, 0, 0)',
    },
    '40%, 60%': {
      transform: 'translate3d(4px, 0, 0)',
    },
  },
  // Alt mesajlar için de beyaz renk
  '& .MuiTypography-root': {
    color: '#fff',
  },
  // Kalın yazılar için stil
  '& .MuiBox-root': {
    color: '#fff',
    fontWeight: 'bold',
  }
}));